import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { Youtube, MessageCircle, Twitter, Instagram } from 'lucide-react';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t-2 border-kquest-700 bg-kquest-950/80 backdrop-blur-xl">
      <div className="container-wide px-6 sm:px-10 lg:px-16 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-kquest-300">{t('footer.tagline')}</p>
        </div>

        <div>
          <h4 className="text-sm font-pixel uppercase tracking-wider text-kquest-100 mb-4">
            {t('footer.links_legal')}
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tos" className="text-kquest-300 hover:text-gold-400">{t('footer.tos')}</Link></li>
            <li><Link to="/privacy" className="text-kquest-300 hover:text-gold-400">{t('footer.privacy')}</Link></li>
            <li><Link to="/cookies" className="text-kquest-300 hover:text-gold-400">{t('footer.cookies')}</Link></li>
            <li><Link to="/refunds" className="text-kquest-300 hover:text-gold-400">{t('footer.refunds')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-pixel uppercase tracking-wider text-kquest-100 mb-4">
            {t('footer.links_community')}
          </h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="flex items-center gap-2 text-kquest-300 hover:text-gold-400"><Youtube className="w-4 h-4" />{t('footer.youtube')}</a></li>
            <li><a href="#" className="flex items-center gap-2 text-kquest-300 hover:text-gold-400"><MessageCircle className="w-4 h-4" />{t('footer.discord')}</a></li>
            <li><a href="#" className="flex items-center gap-2 text-kquest-300 hover:text-gold-400"><Twitter className="w-4 h-4" />{t('footer.twitter')}</a></li>
            <li><a href="#" className="flex items-center gap-2 text-kquest-300 hover:text-gold-400"><Instagram className="w-4 h-4" />{t('footer.instagram')}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-pixel uppercase tracking-wider text-kquest-100 mb-4">
            {t('footer.links_creator')}
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-kquest-300 hover:text-gold-400">{t('footer.about')}</Link></li>
            <li><Link to="/press" className="text-kquest-300 hover:text-gold-400">{t('footer.press')}</Link></li>
            <li><Link to="/contact" className="text-kquest-300 hover:text-gold-400">{t('footer.contact')}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t-2 border-kquest-700 px-6 sm:px-10 lg:px-16 py-6 text-xs text-kquest-400 text-center font-pixel">
        © {year} K-Quest · {t('footer.rights')}
      </div>
    </footer>
  );
}
